var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 6.14282L11.6875 9.29907C12.0938 9.67407 12.0938 10.2991 11.6875 10.6741L11 11.3616C10.625 11.7678 10 11.7678 9.625 11.3616L6.5 8.23657L3.34375 11.3616C2.96875 11.7678 2.34375 11.7678 1.96875 11.3616L1.28125 10.6741C0.875 10.2991 0.875 9.67407 1.28125 9.29907L4.40625 6.14282L1.28125 3.01782C0.875 2.64282 0.875 2.01782 1.28125 1.64282L1.96875 0.955322C2.34375 0.549072 2.96875 0.549072 3.34375 0.955322L6.5 4.08032L9.625 0.955322C10 0.549072 10.625 0.549072 11 0.955322L11.6875 1.64282C12.0938 2.01782 12.0938 2.64282 11.6875 3.01782L8.5625 6.14282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.20e53430212775e098ddf6498bffef60.svg";
export { ForwardRef as ReactComponent };